import React from 'react';
import { connect } from 'react-redux';
import MobileWrapper from  './MobileWrapper';
import DayOverview from './DayOverview';
import { day } from './actions';
// import { Tabs } from 'antd';
import Tabs from 'antd/lib/tabs';

const TabPane = Tabs.TabPane;

class MobileContainer extends React.Component {

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	reload() {
		console.log('reload Page')
	}

	changeDay(key) {
		this.props.day(key)
	}

	render() {
		return(
			<div>
				<MobileWrapper>				
					<Tabs defaultActiveKey={this.props.gui.day}
						onChange={this.changeDay.bind(this)}
						className={'tabs-full-width--3'}>
				    <TabPane tab="Montag" key="1">
							<DayOverview
								day={'Montag'}
								dishes={'monday'} />
				    </TabPane>
				    <TabPane tab="Dienstag" key="2">
				    	<DayOverview
								day={'Dienstag'}
								dishes={'tuesday'} />
				    </TabPane>
				    <TabPane tab="Mittwoch" key="3">
				    	<DayOverview
								day={'Mittwoch'}
								dishes={'wednesday'} />
				    </TabPane>
				    <TabPane tab="Donnerstag" key="4">
				    	<DayOverview
								day={'Donnerstag'}
								dishes={'thursday'} />
				    </TabPane>
				    <TabPane tab="Freitag" key="5">
				    	<DayOverview
								day={'Freitag'}
								dishes={'friday'} />
				    </TabPane>
				  </Tabs>
				</MobileWrapper>

			</div>
		);
	}
}

const mapStateToProps = state => ({
	gui: state.gui,
})

const mapDispatchToProps = dispatch => ({
	dispatch,
	day(key) {
		dispatch(day(key.toString()));
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileContainer);


// export default MobileContainer;


// WEBPACK FOOTER //
// ./src/gui/MobileContainer.js